import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import withRouter from "../withRouter";
import customFetch from "../../../helpers/fetchClient";

// Mapping des rôles
const ROLE_LABELS = {
  1: "Super Admin",
  2: "Admin",
  3: "Manager",
  4: "Créateur",
  5: "Utilisateur",
};

const ROLE_BADGES = {
  1: "danger",
  2: "warning",
  3: "primary",
  4: "info",
  5: "secondary",
};

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const [user, setUser] = useState(null);

  const navigate = useNavigate();

  // Fetch l'utilisateur connecté via API
  const fetchUser = async () => {
    try {
      const data = await customFetch("/api/user/me");
      setUser({
        name: data.name || "Utilisateur",
        surname: data.surname || "",
        role: data.role || 5, // fallback utilisateur
      });
    } catch (err) {
      console.error(err);
      setUser({ name: "Utilisateur", surname: "", role: 5 });
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  // Déconnexion
  const handleLogout = () => {
    localStorage.removeItem("authUser");
    navigate("/auth-login");
  };

  if (!user) return null; // ou loader si tu veux

  const fullName = `${user.name} ${user.surname}`.trim();
  const roleLabel = ROLE_LABELS[Number(user.role)] || "Rôle inconnu";
  const roleBadge = ROLE_BADGES[Number(user.role)] || "secondary";

  return (
    <Dropdown
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="d-inline-block"
    >
      <DropdownToggle
        className="btn header-item"
        id="page-header-user-dropdown"
        tag="button"
      >{/* 
        <img
          className="rounded-circle header-profile-user"
          src="images/users/png-clipart-computer-icons-user-profile-avatar-face-heroes.png"
          alt="Avatar"
        /> */}

        <span className="d-none d-xl-inline-block ms-2 me-1 fw-semibold">
          {fullName}
        </span>

        {/* <Badge
          color={roleBadge}
          pill
          className="d-none d-xl-inline-block me-2"
          style={{ fontSize: "0.65rem", padding: "0.25em 0.4em" }}
        >
          {roleLabel}
        </Badge> */}

        <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          tag="button"
          className="dropdown-item"
          onClick={() => navigate("/userprofile")}
        >
          <i className="ri-user-line align-middle me-2" />
          {props.t("Profile")}
        </DropdownItem>

        <div className="dropdown-divider" />

        <button className="dropdown-item" onClick={handleLogout}>
          <i className="ri-shut-down-line align-middle me-2 text-danger" />
          <span>{props.t("Logout")}</span>
        </button>
      </DropdownMenu>
    </Dropdown>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license